

































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import AbpBase from '../../lib/abpbase'
    import OrderManagement from '../../store/entities/ordermanagement'
    @Component
    export default class EditOrderDispose extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        ordermanagement:OrderManagement=new OrderManagement();
       
       
        save(){
              var l=  this.$refs.ordermanagementForm
             //  alert(this.ordermanagement.id)
            /*
            if(this.ordermanagement.type==1){
                this.ordermanagement.status=2;
            }
          var l=  this.$refs.ordermanagementForm as any;
          l.status=this.ordermanagement.status;
          l.type=3;
          l.cid=this.ordermanagement.cid;
          l.wtid=this.ordermanagement.wtid;
          l.weight=this.ordermanagement.weight;
    
            (this.$refs.ordermanagementForm as any).validate(async (valid:boolean)=>{
               
                if(valid){
                    await this.$store.dispatch({
                        type:'ordermanagement/create',
                        data:this.ordermanagement
                    });
                    (this.$refs.ordermanagementForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
            */
            if(this.ordermanagement.type==2){
                this.ordermanagement.status=2;
            }
           (this.$refs.ordermanagementForm as any).validate(async (valid:boolean)=>{
                if(valid){
                    var  parm={ id :this.ordermanagement.id,status:this.ordermanagement.status,updatetime1:this.ordermanagement.updatetime1};
                    await this.$store.dispatch({
                        type:'ordermanagement/updatestatus',
                        data:parm
                    });
               /* var  parm={ id :id,status:status};
            await this.$store.dispatch({
                type:'ordermanagement/updatestatus',
                data:parm
            })*/

                    (this.$refs.ordermanagementForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
         /*
         async updatestatus(id,status,){
            
              var  parm={ id :id,status:status};
                 await this.$store.dispatch({
                type:'ordermanagement/updatestatus',
                data:parm
            })
        }*/
         
         isActiveChange(val:string){
                
          
        }
        isOrderType(val:string){
        if(val=="1"){
              this.$store.state.ordermanagement. statusselected=2; 
               this.$store.state.ordermanagement. isShowStatus=false;
                

        }else{
            
               this.$store.state.ordermanagement. statusselected=1; 
               this.$store.state.ordermanagement. isShowStatus=true;
             

        }}
        cancel(){
            (this.$refs.ordermanagementForm as any).resetFields();
            this.$emit('input',false);
        }
        
        ordermanagementRule={
            // operators1:[{type:'string',required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderSignfoOperators1'))}],
            
        }

          currentTime() {
          let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        hours: nowDate.getHours(),
        minutes: nowDate.getMinutes(),
        seconds: nowDate.getSeconds(),
      };      
      let newmonth = date.month > 10 ? date.month : "0" + date.month;
      let newday = date.date > 10 ? date.date : "0" + date.date;
      let newminutes = date.minutes < 10 ? "0" + date.minutes : date.minutes;
      let newseconds = date.seconds < 10 ? "0" + date.seconds : date.seconds;
      // 我需要的时间格式为 "yyyy-MM-dd HH:mm:ss" 有不一样的自己拼别的，都是字符串拼接
      let newTime =
        date.year +
        "-" +
        newmonth +
        "-" +
        newday +
        " " +
        date.hours +
        ":" +
        newminutes +
        ":" +
        newseconds;
        return newTime;
}

created() {
  
}

visibleChange(value:boolean){
          
            if(!value){
                this.$emit('input',value);
            }else{
                this.ordermanagement=Util.extend(true,{},this.$store.state.ordermanagement.editOrderManagement);
                  if(this.ordermanagement.updatetime1==null){
                    this.ordermanagement.updatetime1=new Date(this.currentTime()) ;
                  }
                 
                //
                // this.$refs.ordermanagementForm =this.ordermanagement as any;
                  
                // console.log( this.$refs.ordermanagementForm)

            }
        }
        
    }
